import { InjectionToken } from '@angular/core';
import { LocalCache } from '@nk/caching-lib';
import { CompanyLegalRightCompositeEntity } from '@nk/data-entities-lib';
import { Observable } from 'rxjs';

export interface CompanyLegalRightApiService {
  companyLegalRightCompositeCache: LocalCache<
    this,
    (
      companyUuid?: string,
      rightsholderCompanyUuid?: string,
      rightsholderPersonUuid?: string,
      legalRightUuid?: string,
    ) => Observable<CompanyLegalRightCompositeEntity[]>
  >;
}
export const COMPANY_LEGAL_RIGHT_API_SERVICE_TOKEN = new InjectionToken<CompanyLegalRightApiService>(
  'CompanyLegalRightApiService',
);
